<template>
  <div class="up-file-wrapper">
    <el-upload
      class="file-uploader"
      :before-remove="() => false"
      :action="action"
      :data="fileUpParam"
      :file-list="up_fileList"
      :before-upload="beforeUpload"
      :on-change="upStateChange"
      :on-success="uploadSuccess"
      :headers='fileUpHeaders'
      ref="fileUp"
    >
      <el-button type="primary" class="upload-btn">
        上传
        <i class="el-icon-upload el-icon--right"></i>
      </el-button>
      <div slot="tip" class="el-upload__tip">{{upload_tip}}</div>
    </el-upload>
    <slot name="download"></slot>
  </div>
</template>

<script>
  import {storageData} from "@/assets/js/storage";

export default {
  name: "FileUploadVue",
  props: {
    val: {
      required: true
    },
    // fileName: {
    //   type: String,
    //   required: true
    // },
    action: {
      type: String,
      required: true
    },
    up_fileList: {
      type: Array,
      // required: true
    },
    test_file: {
      type: Object,
      default: () => {
        return {
          type: null,
          size: null
        };
      }
    },
    upload_tip: {
      type: String
    }
  },
  data() {
    return {
      fileUpParam: {},
      fileUpHeaders: {'X-Token': storageData.getToken(),"X-UserType":storageData.getUserType()},
    };
  },
  methods: {
    beforeRemove() {
      return false;
    },
    upStateChange(file, fileList) {
      this.$emit("update:up_fileList", fileList.slice(-1));
    },
    beforeUpload(file) {
      // console.log("上传文件 === ", file);
      const testFile = this.test_file;
      const judgeType = data => {
        return Object.prototype.toString
          .call(data)
          .slice(8, -1)
          .toLocaleLowerCase();
      };

      let isTypeTrue = true,
        isSizeTrue = true;

      judgeType(testFile.type) === "object" &&
        (isTypeTrue = testFile.type.reg.test(file.name));
      judgeType(testFile.size) === "object" &&
        (isSizeTrue = file.size / 1024 / 1024 <= testFile.size.reg);

      if (!isTypeTrue) {
        this.$message.error(testFile.type.msg);
      }
      if (!isSizeTrue) {
        this.$message.error(testFile.size.msg);
      }

      // 若返回 false 则会停止上传
      if (!(isTypeTrue && isSizeTrue)) {
        // 文件不通过校验,清空上传文件列表
        this.$nextTick(() => {
          this.reset();
        });
        return false;
      }

      let param = {
        excel: file
      };

      for (const key in param) {
        if (param.hasOwnProperty(key)) {
          this.$set(this.fileUpParam, key, param[key]);
        }
      }
    },
    uploadSuccess(res, file, fileList) {
      if (res.status === 0) {
        this.$emit("update:val", res.result);
        // this.$emit("update:fileName", file.name);
        this.$emit("update:up_fileList", fileList.slice(-1));
      } else {
        this.$nextTick(() => {
          this.reset();
        });
        this.$message.error(res.msg);
      }
    },
    reset(isBeforeUp = true) {
      isBeforeUp && this.$refs["fileUp"].clearFiles();
      // this.imgList = [];
      this.$emit("update:up_fileList", []);
      this.$emit("update:val", "");
      // this.$emit("update:fileName", '');
    }
  }
};
</script>

<style lang="stylus">
.up-file-wrapper 
  position relative
  .file-uploader
    display: flex
    flex-direction column
    align-items center
  .upload-btn
    padding 15px 30px
    font-size 20px
</style>

